import React, { Component } from 'react';
import { Container, Segment, Header, Table, Button, Label } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import Moment from 'moment';
import _ from 'underscore';
import { connect } from 'react-redux';
import { 
    getAllClaims, 
    getClaimOptionsEclaim, 
    updateClaimFilterOptions,
    getVisitsListAction, 
    viewUserAction 
} from '../../actions';
import ClaimStatusLabel from '../../component/claim/claim_status_label';
import ClaimFilterRecords from '../../component/claim/claim_filter_records';

const typeOfClaimList = {
    1 : "Panel Visit",
    2 : "Inpatient Claim",
    3 : "Outpatient Claim"
};

class PanelVisitPage extends Component {

    state = {
        direction: 'ascending',
        claimRecords: [],
        latestClaims: [],
    }

    componentDidMount() {
        this.fetchClaims();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { claimFilterOptions, contactNoVerified } = prevProps;
        const { fromDate, toDate, filterByClaimant, filterByCompany } = this.props.claimFilterOptions;
        if (fromDate !== claimFilterOptions.fromDate || toDate !== claimFilterOptions.toDate || filterByClaimant !== claimFilterOptions.filterByClaimant || filterByCompany !== claimFilterOptions.filterByCompany || contactNoVerified !== this.props.contactNoVerified) {
            this.fetchClaims();
        }
    }

    fetchClaims() {
        const { accessToken, uuid, companies} = this.props.user;
        const companyId = this.props.claimFilterOptions.filterByCompany ? this.props.claimFilterOptions.filterByCompany : this.props.user.companies[0].companyId

        // this.props.getClaimUserPlanConfigBenefit({ accessToken, companyId });
        this.props.getAllClaims({claimFilterOptions: this.props.claimFilterOptions, accessToken, companyId}, (result, error)=>{
            if (result) {
                this.sortedClaims()
            }
        });
        this.props.getClaimOptionsEclaim(this.props.user.accessToken, companyId);
    }

    handleSort (){
        const { direction } = this.state

        this.setState({
            direction: direction === 'descending' ? 'ascending' : 'descending'
        })
    }

    sortedClaims (){
        const { direction } = this.state
        console.log(this.props.claimsList)
        let sortedClaimsListSubmitted = this.props.claimsList.filter(data => data.s !== "PROCESSING").sort(function(data) {
        // let sortedClaimsListSubmitted = this.props.claimsList.filter(data => data.s !== "PROCESSING" && data.t === 1).sort(function(data) {
            let dateString = ''
            if (data.vd !== '') {
                dateString = data.vd
            }

            let date = new Moment(dateString, "DD/MM/YYYY");

            if (direction === 'descending') {
                return date;
            }
            return -date;
        })

        return sortedClaimsListSubmitted;
    }
    
    renderClaimRecord(sortedClaimsList){
        return (
            <>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Reference Number</Table.HeaderCell>
                        <Table.HeaderCell
                            sorted={this.state.direction}
                            onClick={() => this.handleSort()}>
                            Visit Date
                        </Table.HeaderCell>
                        <Table.HeaderCell>Clinic / Hospital / Provider</Table.HeaderCell>
                        <Table.HeaderCell>Type</Table.HeaderCell>
                        {this.props.configBenefit.featuresConfig.allowChat && (
                            <Table.HeaderCell>Chat</Table.HeaderCell>
                        )}
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {
                        _.map(sortedClaimsList, (claim) => {
                            const {
                                t, // 1-panel visit, 2-inpatient claim, 3-outpatient claim
                                p, // provider name
                                c, // currency (in/out only: 2/3)
                                ia, // incurred amount
                                s, // status (in/out only: 2/3)
                                tx, // transaction no. (in/out only: 2/3)
                                vn, // visit number
                                vd, // date of visit (panel/in: 1/2)
                                id,
                                ad, // admission date (out: 3)
                                retry,
                                pi, // pending insurer
                            } = claim;
                            if (tx || vn) {
                                return (
                                    <Table.Row key={vn}>
                                        <Table.Cell>
                                            <Link to={(t === 3) ? `/app/claimrecords/out/${tx}` : (t === 2) ? `/app/claimrecords/inp/${tx}` : `/app/visits/${vn}/detail` }>
                                                {tx ? `${vn} / ${tx}` : vn}
                                            </Link>
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Link to={(t === 3) ? `/app/claimrecords/out/${tx}` : (t === 2) ? `/app/claimrecords/inp/${tx}` : `/app/visits/${vn}/detail` }>
                                                {Moment((vd || ad), 'D/M/YYYY').format('DD MMM YYYY')}
                                            </Link>
                                        </Table.Cell>
                                        <Table.Cell>
                                            {p}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {typeOfClaimList[t]}
                                        </Table.Cell>
                                        {this.props.configBenefit.featuresConfig.allowChat && (
                                            <Table.Cell>
                                                { t !== 1 &&
                                                <Link to={`/app/askjoey?type=${ (t === 3)? `outclaim` : `inpclaim`}&id=${encodeURIComponent(tx)}`}>
                                                    <Button>
                                                        Ask May
                                                    </Button>
                                                </Link> }
                                            </Table.Cell>
                                        )}
                                    </Table.Row>
                                );
                            }else if(id){
                                return (
                                    <Table.Row key={id} className={retry >=3 ? "warning-text" : ""}>
                                        <Table.Cell>
                                            <Link to={(t === 3) ? `/app/claimrecords/out/${id}/${s}` : `/app/claimrecords/inp/${id}/${s}`}>
                                                {id}
                                            </Link>
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Link to={(t === 3) ? `/app/claimrecords/out/${id}/${s}` : `/app/claimrecords/inp/${id}/${s}`}>
                                                {Moment((vd || ad), 'D/M/YYYY').format('DD MMM YYYY')}
                                            </Link>
                                        </Table.Cell>
                                        <Table.Cell>
                                            <ClaimStatusLabel status={s} pendingInsurer={pi}/>
                                        </Table.Cell>
                                        <Table.Cell>
                                            {p}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {typeOfClaimList[t]}
                                        </Table.Cell>
                                        {this.props.configBenefit.featuresConfig.allowChat && (
                                            <Table.Cell>
                                                <Link to={`/app/askjoey?type=${ (t === 3)? `outclaim` : `inpclaim`}&id=${encodeURIComponent(id)}`}>
                                                    <Button>
                                                        Ask May
                                                    </Button>
                                                </Link>
                                            </Table.Cell>
                                        )}
                                    </Table.Row>
                                );
                            }
                        })
                    }
                </Table.Body>
            </>  
        )
    }

    renderPanelVisit(sortedClaimsList){
        return (
            <>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Visit Number</Table.HeaderCell>
                        <Table.HeaderCell>Clinic / Hospital / Provider</Table.HeaderCell>
                        <Table.HeaderCell
                            sorted={this.state.direction}
                            onClick={() => this.handleSort()}>
                            Visit/Admission Date
                        </Table.HeaderCell>
                        <Table.HeaderCell>Amount</Table.HeaderCell>
                        <Table.HeaderCell>Status</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {
                        _.map(sortedClaimsList, (claim) => {
                            const { vid, vd, p, vn, statusType, sca } = claim;
                            return (
                                <Table.Row key={vid}>
                                    <Table.Cell>
                                        <Link to={`/app/visits/${vn}/${vid}`}>
                                            {vn}
                                        </Link>
                                    </Table.Cell>
                                    <Table.Cell>
                                        {p}
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Link to={`/app/visits/${vn}/${vid}`}>
                                            {Moment((vd), 'D/M/YYYY').format('DD MMM YYYY')}
                                        </Link>
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Label color='green' horizontal>SGD</Label>
                                        {`${sca}`}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {statusType}
                                    </Table.Cell>
                                </Table.Row>
                            );
                        })
                    }
                </Table.Body>
            </>  
        )
    }

    render() {
        var sortedClaimsList = this.sortedClaims()

        return (
            <Container fluid>
                <Header as='h2' attached='top' block>
                    My Visits
                </Header>
                <Segment attached>
                    <ClaimFilterRecords
                        claimFilterOptions={this.props.claimFilterOptions}
                        user={this.props.user}
                        updateClaimFilterOptions={this.props.updateClaimFilterOptions}
                    />
                </Segment>
                <Segment>
                    <Table sortable celled selectable>
                        {this.renderClaimRecord(sortedClaimsList)}
                    </Table>
                </Segment>
            </Container>
        );
    }
}

function mapStateToProps(state) {
    return {
        claimFilterOptions: state.claims.filterOptions,
        claims: state.claims.claims,
        claimsList: state.claims.data,
        isLoaded: state.claims.isLoaded,
        user: state.user.user,
        configBenefit: state.user.configBenefit,
    };
}

export default connect(mapStateToProps, {
    getAllClaims,
    getClaimOptionsEclaim,
    updateClaimFilterOptions,
    getVisitsListAction,
    viewUserAction
})(PanelVisitPage);
